import React from 'react';
import { Link } from 'react-router-dom';
import Loader from './../../component/common/Loader';
import logo from "./../../assets/images/logo.png";

import CONSTANT from './../../constant';
import { onChange, validateForm } from './../../utils';
import { forgotPassword } from './../../actions/AuthAction';
import constant from './../../constant';

class ComponentName extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            employeeNumber: { name: 'employeeNumber', value: '', error: '', isRequired: true },
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.forgotPassword;
    }

    render() {
        const { employeeNumber, showLoader } = this.state;
        return (
            <>
                {
                    showLoader && <Loader />
                }
                {/* new code  */}

                <div className="login-21">
                    <div className="container-fluid">
                        <div className="row login-box60">
                            <div className="col-lg-5 form-text">
                                <div className="info clearfix">
                                    <div className="animate-charcter">
                                        <img src={logo} alt="logo" />
                                    </div>
                                    <p>ईपीआई स्पैरो पोर्टल / EPI SPARROW PORTAL</p>
                                </div>
                            </div>
                            <div className="col-lg-7 align-self-center form-section">
                                <div className="form-inner">
                                    <h1>EPI SPARROW PORTAL</h1>
                                    <form onSubmit={this.onSubmit}>
                                        <div className="form-group form-box">
                                            <input
                                                type="text"
                                                className={employeeNumber.error.length > 0 ? 'form-controll has-validation' : 'form-controll'}
                                                placeholder="Enter employee code"
                                                name={employeeNumber.name}
                                                value={employeeNumber.value}
                                                onChange={this.onChange}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <button
                                                type="submit"
                                                className="btn-md btn-theme w-100"
                                            >
                                                Send email
                                            </button>
                                        </div>
                                    </form>
                                    <div className="clearfix" />
                                    <div className="extra-login form-group clearfix">
                                        <span>OR</span>
                                    </div>
                                    <div className="clearfix" />
                                    <div className="form-group">
                                        <Link className="btn-md btn-otp" to={constant.component.home.url}>Back to login</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* old code  */}
                {/* <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-4 offset-md-4">

                            <div className="flex flex-col justify-center mt-5">
                                <img src={logo} alt="logo" />
                                <p className="text-center mb-2">
                                    ई-आफ़िस पोर्टल / e-Office Portal
                                </p>
                            </div>

                            <div className="card mt-5">
                                <div className="card-header">
                                    Forgot password
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.onSubmit}>
                                        <div className="form-group">
                                            <label>Employee Code</label>
                                            <input
                                                type="text"
                                                className={employeeNumber.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                placeholder="Employee number"
                                                name={employeeNumber.name}
                                                value={employeeNumber.value}
                                                onChange={this.onChange}
                                            />
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <Link to={CONSTANT.component.login.url}>
                                                    Back to login
                                                </Link>
                                            </div>
                                            <div className="col-md-6">
                                                <button type="submit" className="btn btn-block submit-button btn-sm">Send email</button>
                                            </div>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>

                    </div>
                </div> */}
            </>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }


    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            this.setState({ showLoader: true });
            const st = this.state;
            const model = {
                employeeNumber: st.employeeNumber.value,
            };


            forgotPassword(model).then((res: any) => {
                this.setState({ showLoader: false });
                if (res) {
                    if (res.status === CONSTANT.static.apiStatus.success) {
                        alert(res.result.message)
                        this.props.history.push(CONSTANT.component.home.url);
                    } else {
                        alert(res.error);
                    }
                }
            });

        }
    }
}

export default ComponentName;